// Generated by Melange


const cdnBaseUrl = "https://assets.buhtacdn.com";

function src(src$1) {
  return cdnBaseUrl + src$1;
}

export {
  cdnBaseUrl ,
  src ,
}
/* No side effect */
